var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['tab-button', { active: _vm.active }],attrs:{"data-external":_vm.dataExternal,"role":"radio","aria-checked":_vm.active},on:{"click":function($event){return _vm.$emit('change', _vm.value)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }